import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, navigateTo, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import menuEntrepriseMenuStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'menuEntrepriseMenu'
const customImplement: CustomStoreImplementationOptions = menuEntrepriseMenuStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function menuEntrepriseMenuFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('menu-entreprise.title', 'Menu Entreprise'),
        $description: $translate('menu-entreprise.description', ''),
        $publishedTime: new Date('2023-02-20T10:46:16.417Z'),
        $modifiedTime: new Date('2023-05-24T08:25:00.191Z'),
        // Constants,
        $constants: {},
        // Data,
        $info: { menuEntreprise: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      async pourquoiMatchersClick () {
        await navigateTo({ name: 'hub-entreprise' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async commentCaMarcheClick () {
        await navigateTo({ name: 'hub-entreprise-Fonctionnement' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async blogClick () {
        await navigateTo({ name: 'Blog' })
      },
      /* @ts-ignore: to allow override in your custom file */
      async container3Click () {
        await navigateTo({ name: 'Blog' })
      },
      /* @ts-ignore: to allow override in your custom file */
      rechercherUnExpertClick () {
        openUrl('/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      container4Click () {
        openUrl('/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return menuEntrepriseMenuFactory(storeId)()
}

export const menuEntrepriseMenuRaw = menuEntrepriseMenuFactory()
export const menuEntrepriseMenu = () => menuEntrepriseMenuRaw() as MergeCustomStore<typeof menuEntrepriseMenuStoreCustom.instance>
